import React from 'react';
import { Shield, MapPin, Award, Phone } from 'lucide-react';
export function TrustStrip() {
  const features = [{
    icon: <Shield className="w-5 h-5 md:w-6 md:h-6" data-id="element-243" />,
    label: 'Licensed & Insured',
    detail: 'CA #947943',
    description: 'Fully protected for your peace of mind'
  }, {
    icon: <MapPin className="w-5 h-5 md:w-6 md:h-6" data-id="element-244" />,
    label: 'Local to Fresno',
    detail: 'Serving 5 Counties',
    description: 'Deeply rooted in the Central Valley'
  }, {
    icon: <Award className="w-5 h-5 md:w-6 md:h-6" data-id="element-245" />,
    label: '28+ Years',
    detail: 'Established 1997',
    description: 'Decades of proven craftsmanship'
  }, {
    icon: <Phone className="w-5 h-5 md:w-6 md:h-6" data-id="element-246" />,
    label: 'Direct Contact',
    detail: 'Owner-Managed',
    description: 'Personal service from start to finish'
  }];
  return <div className="relative -mt-20 z-20" data-id="element-247">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-249">
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-gray-100" data-id="element-250">
            {features.map((feature, index) => <div key={index} className="p-4 md:p-10 group hover:bg-gray-50 transition-colors duration-300" data-id="element-251">
                <div className="flex flex-col items-center text-center" data-id="element-252">
                  <div className="inline-flex items-center justify-center w-10 h-10 md:w-16 md:h-16 bg-brand-blue/5 rounded-xl md:rounded-2xl text-brand-blue mb-2 md:mb-6 group-hover:scale-110 group-hover:bg-brand-blue/10 transition-all duration-300" data-id="element-253">
                    {feature.icon}
                  </div>
                  <h3 className="font-bold text-brand-black text-sm md:text-lg mb-1 md:mb-2" data-id="element-254">
                    {feature.label}
                  </h3>
                  <div className="inline-flex items-center px-2 py-0.5 md:px-3 md:py-1 rounded-full bg-brand-blue/5 text-brand-blue text-xs md:text-sm font-semibold mb-1 md:mb-4" data-id="element-255">
                    {feature.detail}
                  </div>
                  <p className="text-xs md:text-sm text-brand-gray leading-relaxed hidden md:block" data-id="element-256">
                    {feature.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}